module.exports = __webpack_public_path__ + "static/media/bosch-logo.979eae5e.avif";